import { render, staticRenderFns } from "./Base.version.1.vue?vue&type=template&id=76731eac&scoped=true&"
import script from "./Base.version.1.vue?vue&type=script&lang=js&"
export * from "./Base.version.1.vue?vue&type=script&lang=js&"
import style0 from "./Base.version.1.vue?vue&type=style&index=0&id=76731eac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76731eac",
  null
  
)

export default component.exports